import {isNil} from "../Helper";

export default function damageReportForm()  {

  const damageReportForm = document.getElementById('damagereport__form')
  if (!isNil(damageReportForm)) {
    document.getElementById('bgr_damage_report[damagedDevice]').addEventListener('input', function (event) {
      const brandAndModelContainer = document.getElementById('deviceModelMakeAndSerialHelp');

      if (event.target.value !== '') {
        brandAndModelContainer.classList.add("show");
      } else {
        brandAndModelContainer.classList.remove("show");
      }
    }, false);
  }
}
